import React, { useEffect, useMemo, useState } from "react"
import { COLUMNS4 } from "./PatientColumns"
import Table from "../../../components/Table"
import { useSelector } from "react-redux"
import {
  getAllCenters,
  getallPatientDetail
} from "../../../core/services/api"
import "./PatientDirectory.scss"
import { useHistory, useLocation } from "react-router"
import Button from "../../../components/Button"
import ViewTransferPatient from "../../CenterAdmin/ViewTransferPatient/ViewTransferPatient"
import { MocUserRole } from "../../../core/services/models/Enums"
import Select from "react-select"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons"

function PatientTransfer(props: any) {
  const { selectedCenter } = props
  const userRole = useSelector((state: any) => state?.user?.role)
  const readOnlys = useSelector((state: any) => state?.user?.readOnly)
  const location = useLocation()
  const history = useHistory()

  const [viewTransferPatient, setViewTransferPatient] = useState<any>(false)
  const [patientId, setPatientId] = useState<any>()

  const columns = useMemo(() => {
    let cols: any = [...COLUMNS4]

    let transferPatCol = cols.find((each: any) => each?.accessor === "transfer patient");
    if (
      [MocUserRole.CENTER_ADMIN].includes(userRole) &&
      (!transferPatCol || Object.keys(transferPatCol).length === 0)
    ) {
      cols.push(
        {
          Header: "",
          accessor: "transfer patient",
          Cell: (props: any) => {
            if (props?.row?.original?.survivalStatus === "Alive") {
              return (
                <div>
                  <Button
                    text="Transfer"
                    outline={true}
                    onClick={() => setViewTransferPatient(!viewTransferPatient)}
                    id="transfer"
                    disabled={readOnlys}
                  />
                </div>
              )
            } else {
              return (
                <div></div>
              )
            }
          }
        },
      )
    }
    return cols
  }, [userRole, location])

  const [data, setData] = useState<any>([])

  //Search For Patient Directory
  const [searchText, setSearchText] = useState<any>("")
  const [centerOptions, setCenterOptions] = useState<any>([])
  const [centerFilter, setCenterFilter] = useState<any>("")


  useEffect(() => {
    getAllCenters()
      .then((res: any) => {
        const tempCenters: any = res?.map((each: any) => {
          return { label: each?.centerName, value: each?.id }
        })
        setCenterOptions(tempCenters)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    if (searchText && searchText?.length > 6 && searchText?.match(/\d/g)?.length >= 1) {
      let url = `?sortBy=createdAt&searchText=${searchText}`
      if (centerFilter) {
        url += `&centerId=${centerFilter}`
      }
      getallPatientDetail(url)
        .then((res) => {
          const { data } = res
          const response = data?.filter(
            (each: any) => !each?.isDeleted || each?.isDeleted === false
          )
          if (response?.length > 0) {
            setData(response)
          } else {
            setData([])
          }
        })
        .catch((err) => {
          console.log("err", err)
        })
    } else {
      setData([])
    }
  }, [userRole, location, selectedCenter, searchText?.trim(), centerFilter])

  const handleTransferPatient = (id: any) => {
    setPatientId(id)
  }

  return (
    <div className="patient-directory-wrapper">
      <div className="heading-directory">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"

          />
          <span className="manage-patient-heading">Patient Transfer</span>
        </div>
      </div>

      <div className="col-md-3 col-lg-3">
        <div>
          <label className="location-label">Location : </label>
        </div>
        <div className="d-flex w-100 align-items-center">
          <div className="w-100">
            <Select
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}
              options={centerOptions}
              onChange={(option: any) => {
                setCenterFilter(option?.value)
              }}
              placeholder="Select Location..."
              value={centerOptions?.filter(({ value }: any) => value === centerFilter)}
            />
          </div>
          {centerFilter && <FontAwesomeIcon
            className="ms-2"
            size="lg"
            role="button"
            icon={faCircleXmark}
            onClick={() => { setCenterFilter("") }}
          />}
        </div>
      </div>
      <div className="mt-4 mb-0 location-label">Search by Patient ID / Phone number:</div>
      <Table
        data={data}
        columns={columns}
        globalFilterRequired={true}
        onColClick={(colValue: any, id: any, patientId: any, rowData: any) => {
          if (colValue?.toLowerCase() === "transfer patient") {
            if (rowData?.survivalStatus != "Deceased") {
              handleTransferPatient(id)
              setViewTransferPatient(true)
            }
          }
        }}
        onRowClick={(id: any) => { }}
        enablePagination={false}
        searchText={searchText}
        setSearchText={setSearchText}
      />
      <div>
        {viewTransferPatient === true && (
          <ViewTransferPatient
            show={viewTransferPatient}
            closePrintModal={(close: boolean) => {
              setViewTransferPatient(close)
              window.location.reload()
            }
            }
            id={patientId}
          />
        )}
      </div>
    </div >
  )
}

export default PatientTransfer
